import gql from 'graphql-tag';

export default gql`
  mutation MeShoppingListMarkProductAsBoughtMutation(
    $request: UserShoppingListMarkProductInputType
  ) {
    me {
      shoppingListMarkProductAsBought(request: $request) {
        ... on UserShoppingListMarkProductAsBoughtSuccess {
          code
          isBought
        }
      }
    }
  }
`;
